'use client';

import classNames from '@sindresorhus/class-names';
import dynamic from 'next/dynamic';
import React, {useState} from 'react';

import {rustoreOpenTestIds} from '@web-landing/constants/test-ids/mainLandingTestIds';

import {Footer as FooterType, RuStoreOpenForm} from '@web-landing/strapi/types';

import {OmicronResponse} from '@web-landing/omicron/schemas';

import {log} from './analytics';
import styles from './RustoreOpen.module.scss';

const RuStoreOpenModal = dynamic(
  async () =>
    import('@web-landing/components/RuStoreOpenModal/RuStoreOpenModal'),
  {ssr: false},
);

export type Props = {
  footer: FooterType;
  ruStoreOpenForm?: RuStoreOpenForm;
  omicronConfig?: OmicronResponse;
  captchaClientId: string;
  allowByPassCaptcha: string;
};

export const RustoreOpen = ({
  footer,
  ruStoreOpenForm,
  omicronConfig,
  captchaClientId,
  allowByPassCaptcha,
}: Props) => {
  const [modalShown, setModalShown] = useState(false);

  const setShowModal = () => {
    log.footerMediaKitClick('rustoreOpen');
    setModalShown(!modalShown);
  };

  const showRustoreOpen =
    omicronConfig &&
    omicronConfig.config?.WEB_SHOW_RUSTORE_OPEN &&
    footer.RuStoreOpen;

  return (
    <>
      {modalShown && ruStoreOpenForm && (
        <RuStoreOpenModal
          formData={ruStoreOpenForm}
          setShowModal={setShowModal}
          captchaClientId={captchaClientId}
          allowByPassCaptcha={allowByPassCaptcha}
        />
      )}
      {showRustoreOpen && (
        <button
          className={classNames(styles.link)}
          rel="noopener noreferrer"
          onClick={setShowModal}
          data-testid={rustoreOpenTestIds.rustoreOpenShowModalButton}
        >
          {footer.RuStoreOpen}
        </button>
      )}
    </>
  );
};
